import Vue from "vue";
import iView from "iview";
import Util from "../libs/util";
import VueRouter from "vue-router";
import Cookies from "js-cookie";
import { routers, otherRouter, appRouter } from "./router";
import { infoSelect } from "@/api";

Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
  // mode: 'history',
  routes: routers,
};
// console.log('index-outer');
export const router = new VueRouter(RouterConfig);

router.beforeEach(async (to, from, next) => {
  //用来判断token失效的接口
//   let res = await infoSelect();
//   if (res.code == 502) {
//     Cookies.remove("token1");
//   }

  iView.LoadingBar.start();
  Util.title(to.meta.title); 
  if (Cookies.get("token")) {
    if (Cookies.get("locking") === "1" && to.name !== "locking") {
      // 判断当前是否是锁定状态
      next({
        replace: true,
        name: "locking",
      });
    } else if (Cookies.get("locking") === "0" && to.name === "locking") {
      next(false);
    } else {
      if (!Cookies.get("user") && to.name !== "login") {
        // 判断是否已经登录且前往的页面不是登录页
        next({
          name: "login",
        });
      } else if (Cookies.get("user") && to.name === "login") {
        // 判断是否已经登录且前往的是登录页
        Util.title();
        next({
          name: "home_index",
        });
      } else {
        const curRouterObj = Util.getRouterObjByName(
          [otherRouter, ...appRouter],
          to.name
        );
        if (curRouterObj && curRouterObj.access !== undefined) {
          // 需要判断权限的路由
          if (curRouterObj.access === parseInt(Cookies.get("access"))) {
            Util.toDefaultPage(
              [otherRouter, ...appRouter],
              to.name,
              router,
              next
            ); // 如果在地址栏输入的是一级菜单则默认打开其第一个二级菜单的页面
          } else {
            next({
              replace: true,
              name: "error-403",
            });
          }
        } else {
          // 没有配置权限的路由, 直接通过
          Util.toDefaultPage([...routers], to.name, router, next);
        }
      }
    }
  } else {
    self.location.href = "login.html";
    alert("登录已过期，请重新登录！");
  }
});

router.afterEach((to) => {
  if (router.app.$store) {
    Util.openNewPage(router.app, to.name, to.params, to.query);
  } else {
    Cookies.remove("token");
    let current = Cookies.get("token");
    if (current == "undefined") {
      let arrToken = JSON.parse(window.sessionStorage.getItem("arrToken"));
      Cookies.set("token", arrToken);
      self.location.href = "login.html";
    } else {
      self.location.href = "login.html";
    }
  }

  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
